module.exports = __webpack_public_path__ + "media/images/fast_track-ac9140a7966d1ad361e0e9de2f15f776.svg";